import { RestingDisplay } from '../../resting/resting.util';

export const QTCR_QRS_DUR_THRES_MS = 120;

export const METRICS_MAPPING_STANDARD: Record<string, string> = {
  HR: 'HR',
  JTcF: 'JTcF',
  P: 'P',
  PQ: 'PQ',
  P_axis: 'P axis',
  QRS: 'QRS',
  QRS_axis: 'QRS axis',
  QT: 'QT',
  QTcB: 'QTcB',
  QTcF: 'QTcF',
  Smith: 'Smith 3',
  Smith_4: 'Smith 4',
};

export const METRICS_MAPPING_US: Record<string, string> = {
  ...METRICS_MAPPING_STANDARD,
  PQ: 'PR',
  'min sinus PQ': 'min sinus PR',
};

export const getMetricsMapping = (display: RestingDisplay) =>
  display === 'us' ? METRICS_MAPPING_US : METRICS_MAPPING_STANDARD;
